import find from 'lodash/find';

/**
 * Looks up data in seatData array based on element id
 * Assumes: seat-{num}-{row}-{screen}
 * Optionally accepts a forth key of {section}
 */
export function lookupSeat(id, seatDataCollection) {
  let idParts = id.split('-');

  if (idParts.length) {
    let [prefix, num, row, screen, section] = idParts; // eslint-disable-line no-unused-vars
    return find(seatDataCollection, function findLookupSeat(seat) {
      /**
       * Accounts for seat rows that have spaces in the name,
       * Requires us to remove space when plotting the seat and then
       * normalize here to account for spaces in the name.
       *
       * See: getSeatSelector
       */
      const normalizedRow = seat.seat_row.replace(' ', '');

      if (section) {
        return (
          normalizedRow == row &&
          seat.seat_num == num &&
          seat.screen_no == screen &&
          seat.section == section
        );
      } else {
        return (
          normalizedRow == row &&
          seat.seat_num == num &&
          seat.screen_no == screen
        );
      }
    });
  }
}

/**
 * Common seat selector used for (re)finding seat elements from Tessitura data.
 */
export function getSeatSelector(seatData) {
  /**
   * Accounts for seat rows that have spaces in the name,
   * Requires us to remove space when plotting the seat and then
   * normalize here to account for spaces in the name.
   *
   * See: lookupSeat
   */
  const normalizedRow = seatData.seat_row.replace(' ', '');
  return `seat-${seatData.seat_num}-${normalizedRow}-${seatData.screen_no}`;
}

/**
 * Include section as part of seat selector to aid with disambiguation
 */
export function getSeatSelectorDisambiguated(seatData) {
  return `${getSeatSelector(seatData)}-${seatData.section}`;
}

export function getCustomSeatSelector(seatData) {
  return `syos-custom-icon-${seatData.seat_no}`;
}

export function findSeatEl(seatData) {
  const el = document.getElementById(getSeatSelectorDisambiguated(seatData));

  if (el) {
    return el;
  } else {
    return document.getElementById(getSeatSelector(seatData));
  }
}

export function findCustomSeatEl(seatData) {
  const id = getCustomSeatSelector(seatData);
  return document.getElementById(id);
}

export function findSeatElFromSlug(slug, seatDataCollection) {
  let seatData = lookupSeat(slug, seatDataCollection);
  return seatData ? findSeatEl(seatData) : false;
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/seats/seatFinders.js